<div class="workspace-tab-panel w-100">
  <header class="workspace-section-head mb-4 text-start">
    <h1 class="mb-1">Proba Workflows</h1>
    <p class="mb-0">Turn forms, checks, approvals, and signing into guided workflows that Proba runs for you.</p>
  </header>

  <div class="workspace-card-grid w-100">
    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-coral d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa fa-user-check gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Client Onboarding</h2>
          <p class="mb-0">KYC & Approvals</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Design digital onboarding forms, collect FICA/KYC documents, and run ID, CIPC, or verification checks before routing cases for approval.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button" @click="launch_workspace('design')">
        Start Onboarding Workflow <span aria-hidden="true">&rarr;</span>
      </button>
    </article>

    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-mint d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa fa-building gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Supplier Due Diligence</h2>
          <p class="mb-0">Vendor Workflows</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Onboard suppliers with structured questionnaires, document uploads, automated company checks, and follow-up routing.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button" @click="launch_workspace('onboarding')">
        Start Vendor Workflow <span aria-hidden="true">&rarr;</span>
      </button>
    </article>

    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-purple d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa fa-pen-fancy gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Template Signing</h2>
          <p class="mb-0">Contracts & Agreements</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Use pre-approved templates for NDAs, contracts, and agreements. Assign signers, track status, and keep document workflows version controlled.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button" @click="launch_workspace('signing')">
        Launch Signing Workflow <span aria-hidden="true">&rarr;</span>
      </button>
    </article>
  </div>
</div>
